import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';
import {
    Feature,
    Site,
    User,
} from '@myrtls/api-interfaces';

export const getSiteRequestAction = createAction('[Sites] Get Site Request');

export const getSiteSuccessAction = createAction(
    '[Sites] Get Site Success',
    props<{ site: Site }>(),
);

export const getSiteFailureAction = createAction(
    '[Sites] Get Site Failure',
    props<{ error: HttpErrorResponse }>(),
);

export const getSitesRequestAction = createAction('[Sites] Get Sites Request');

export const getSitesSuccessAction = createAction(
    '[Sites] Get Sites Success',
    props<{ sites: Site[] }>(),
);

export const getSitesFailureAction = createAction(
    '[Sites] Get Sites Failure',
    props<{ error: HttpErrorResponse }>(),
);

export const getSiteUsersRequestAction = createAction(
    '[Sites] Get Site Users Request',
);

export const getSiteUsersSuccessAction = createAction(
    '[Sites] Get Site Users Success',
    props<{ siteId: string; users: User[] }>(),
);

export const getSiteUsersFailureAction = createAction(
    '[Sites] Get Site Users Failure',
    props<{ error: HttpErrorResponse }>(),
);

export const selectSiteAction = createAction(
    '[Sites] Select Site',
    props<{ siteId: string | null }>(),
);

export const inviteUserRequestAction = createAction(
    '[Sites] Invite User Request',
    props<{ user: User }>(),
);

export const inviteUserSuccessAction = createAction(
    '[Sites] Invite User Success',
    props<{ siteId: string; user: User }>(),
);

export const inviteUserFailureAction = createAction(
    '[Sites] Invite User Failure',
    props<{ error: HttpErrorResponse }>(),
);

export const editUserPermissionsRequestAction = createAction(
    '[Sites] Edit User Permissions Request',
    props<{ user: User }>(),
);

export const editUserPermissionsSuccessAction = createAction(
    '[Sites] Edit User Permissions Success',
    props<{ siteId: string; user: User }>(),
);

export const editUserPermissionsFailureAction = createAction(
    '[Sites] Edit User Permissions Failure',
    props<{ error: HttpErrorResponse }>(),
);

export const deleteUserRequestAction = createAction(
    '[Sites] Delete User Request',
    props<{ userId: string }>(),
);

export const deleteUserSuccessAction = createAction(
    '[Sites] Delete User Success',
    props<{ siteId: string; userId: string }>(),
);

export const deleteUserFailureAction = createAction(
    '[Sites] Delete User Failure',
    props<{ error: HttpErrorResponse }>(),
);

export const getSiteFeaturesRequestAction = createAction(
    '[Sites] Get Site Features Request',
);

export const getSiteFeaturesSuccessAction = createAction(
    '[Sites] Get Site Features Success',
    props<{ siteId: string; features: Feature[] }>(),
);

export const getSiteFeaturesFailureAction = createAction(
    '[Sites] Get Site Features Failure',
    props<{ error: HttpErrorResponse }>(),
);

export const getSiteLicenseRawRequestAction = createAction(
    '[Sites] Get Site License Raw Request',
);

export const getSiteLicenseRawSuccessAction = createAction(
    '[Sites] Get Site License Raw Success',
    props<{ siteId: string; licenseRaw: string }>(),
);

export const getSiteLicenseRawFailureAction = createAction(
    '[Sites] Get Site License Raw Failure',
    props<{ error: HttpErrorResponse }>(),
);
